import React from 'react';
import classnames from 'classnames';
export const StyledLabel = ({ children, variant, ...rest }) => (
  <label
    className={classnames('radio-option radio-vertical h-full !rounded-lg', {
      'bg-green-500': variant === 'success',
      'bg-red-500': variant === 'branding',
    })}
    {...rest}
  >
    {children}
  </label>
);

export const StyledCheckbox = ({ children }) => (
  <span className="radio-option-checkbox">{children}</span>
);

export const StyledBody = ({ children, variant }) => (
  <span
    className={classnames('radio-option-body h-full !p-0 flex-col rounded-lg', {
      'bg-green-500': variant === 'success',
      'bg-red-500': variant === 'branding',
    })}
  >
    {children}
  </span>
);

export const StyledButton = ({ children }) => (
  <button type="button" className="rounded-full border-primary bg-none">
    {children}
  </button>
);

export const StyledInput = (props) => <input {...props} className={'radio-option-input'} />;
